import { gql } from "@outschool/ui-apollo";

export const createStripeCheckoutSessionMutation = gql`
  mutation CreateStripeCheckoutSession(
    $plan: String!
    $onSuccessPath: String
    $onCancelPath: String
    $isEmbedded: Boolean
  ) {
    createStripeCheckoutSession(
      plan: $plan
      onSuccessPath: $onSuccessPath
      onCancelPath: $onCancelPath
      isEmbedded: $isEmbedded
    )
  }
`;

export const checkSessionStatusMutation = gql`
  mutation CheckSessionStatus($clientSecret: String!) {
    checkSessionStatus(clientSecret: $clientSecret) {
      paymentStatus
      sessionId
    }
  }
`;
